import { render, staticRenderFns } from "./violationTable.vue?vue&type=template&id=ee399adc&scoped=true"
import script from "./violationTable.vue?vue&type=script&lang=js"
export * from "./violationTable.vue?vue&type=script&lang=js"
import style0 from "./violationTable.vue?vue&type=style&index=0&id=ee399adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee399adc",
  null
  
)

export default component.exports